import type { FaqItem, Principle, TeamMember, Testimonial } from "@/types/melon";

export const siteBrand = {
  name: "深瓜社",
  slogan: "不传谣 · 不站队 · 只把时间线理清楚",
  intro:
    "深瓜社是一个专注事件复盘的中文内容站。我们把公开可查的痕迹按时间排开，附上未删减原稿片段，标注哪些已经确认、哪些仍待验证，让读者在情绪之外看到完整的过程。",
  email: "ti@zhao-shenguashe.com",
  wechat: "shenguashe-daily",
  updateNote: "每周二、周五更新深度选题",
};

export const siteStats = [
  { label: "已整理事件", value: "1,286" },
  { label: "完整时间线", value: "342" },
  { label: "未删减原稿", value: "96" },
  { label: "逐条核查", value: "5,410" },
];

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "瓜田", href: "/topics" },
  { label: "时间线", href: "/timeline" },
  { label: "常见问题", href: "/faq" },
  { label: "关于我们", href: "/about" },
];

export const principles: Principle[] = [
  {
    title: "先排时间线，再谈判断",
    description: "任何结论之前，我们先把能核对的时间点排开，标出证据来自哪里、覆盖了多长区间。",
    icon: "ri-history-line",
  },
  {
    title: "原稿不改一个字",
    description: "引用原始材料时只做必要的标点补全，删减位置会用省略号明确标出，不做无痕改写。",
    icon: "ri-file-text-line",
  },
  {
    title: "空白处就写空白",
    description: "没有公开记录支撑的区间，我们直接标注为待确认，不用推测把故事讲圆。",
    icon: "ri-question-mark",
  },
  {
    title: "不下定论，不站队",
    description: "我们只负责把过程整理清楚，判断留给读者，情绪留给你自己。",
    icon: "ri-scales-3-line",
  },
];

export const team: TeamMember[] = [
  { name: "林知", role: "主编", note: "负责选题方向与事实边界，写过 200+ 篇事件复盘。" },
  { name: "陆迟", role: "时间线编辑", note: "专职整理时间戳与前后顺序，习惯把每一条标注来源。" },
  { name: "顾一鸣", role: "事实核查", note: "逐条交叉验证公开信息，负责标注待确认区间。" },
  { name: "周不晚", role: "视觉编辑", note: "把时间线画成图，让人一眼看懂顺序与间隔。" },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿原",
    role: "关注了 1 年 3 个月",
    quote: "别的号都在下结论，只有这里还在安静地排时间线，看完心里踏实。",
  },
  {
    name: "小满",
    role: "影视从业者",
    quote: "它把物料上下的时间差讲清楚了，这个角度同行看了都点头。",
  },
  {
    name: "老周",
    role: "老读者",
    quote: "最难得的是它肯写「这段没有记录」，而不是硬凑一个解释。",
  },
  {
    name: "椰青",
    role: "大学生",
    quote: "时间线做成图以后太好懂了，比翻几十条碎片舒服多了。",
  },
];

export const faqs: FaqItem[] = [
  {
    question: "深瓜社的内容来源是什么？",
    answer:
      "我们只使用公开发布、可被其他读者自行核对的信息，包括官方通告、节目正片、物料上下线记录、公开的航班与时区信息等。每一篇稿件里，能标注来源的位置都会标注，无法公开的部分会说明原因。",
  },
  {
    question: "「未删减原稿」具体指什么？",
    answer:
      "它指我们能够核对到的、未被二次编辑的原始材料片段，例如场记单节选、顺剪稿标注、素材交接单或完整对话稿。我们只做必要的标点补全，删减位置会用省略号明确标出，不会做无痕改写。",
  },
  {
    question: "完整时间线是怎么整理的？",
    answer:
      "先收集所有带时间戳的痕迹，再按发生顺序排列，最后用独立的公开信息做交叉验证。如果某个时间点只有单一来源，我们会在旁边标注来源数量。找不到支撑的时间区间，会直接标注为待确认。",
  },
  {
    question: "会不会传播未经证实的传闻？",
    answer:
      "不会。无法核对的传闻即使热度很高也不会进入正文，最多在文末的待解问题里作为需要进一步验证的方向出现，并明确写出它目前缺少什么证据。",
  },
  {
    question: "我可以投稿线索吗？",
    answer:
      "可以。我们在关于我们页面提供了线索投稿入口。请尽量附上时间、地点与可核对的材料，例如截图、物料链接或现场记录。涉及个人隐私的内容我们会先做脱敏处理。",
  },
  {
    question: "内容可以转载吗？",
    answer:
      "欢迎注明出处后转载，但请完整保留时间线与来源标注，不要只截取结论部分。二次传播时如果删掉了前提条件，那句话的性质就可能完全改变。",
  },
];